import styled from 'styled-components';

export const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.37);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
`;

export const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  height: 40px;
  width: 100%;
  padding: 8px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 12px 12px 0 0;
  background: var(--Takeat-Colors-Primary-Red, #c8131b);

  .close-icon {
    position: absolute;
    right: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ContainerModal = styled.div`
  display: flex;
  width: 669px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const ContainerInfo = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 0 0 12px 12px;
  background: var(--Takeat-Colors-Neutrals-White, #fff);
`;

export const TextTaxReform = styled.span`
  color: var(--Takeat-Colors-Primary-Red, #c8131b);
  text-align: center;

  /* Title/Title Medium/Semibold | 600 */
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 133.333% */
  letter-spacing: var(--Headline-Small-Tracking, 0);
`;

export const TextInfoReform = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  text-align: center;

  /* Title/Title Small/Medium | 500 */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
  align-self: stretch;
`;

export const ContainerImage = styled.div`
  display: flex;
  width: 649px;
  height: 226px;
  padding: 12px 10px 10px 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 12px;
  background: var(--Takeat-Colors-Neutrals-Grey-05, #f6f6f6);
`;

export const Image = styled.img`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const ContainerAlert = styled.div`
  display: flex;
  width: 645px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  background: var(--Takeat-Colors-Yellow-Variations-00, #fff8eb);
`;

export const TextAlert = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Label/Label Large/Medium | 500 */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
`;

export const TextInfoRefresh = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Label/Label Large/Medium | 500 */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
  flex: 1;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;
